import React, { useState, useEffect } from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { ReportingShellContainerBaseConfig } from '../../../base';
import { ThreadItemController } from './threadItemInterface';
import { ThreadItemContainerProps } from './threadItemProps';
import { useNavigate, useParams } from 'react-router';
import { z } from 'zod';

export function createThreadItemContainer(
    config: ReportingShellContainerBaseConfig,
    controller: ThreadItemController
): React.FC<ThreadItemContainerProps> {
    const {
        context: { useContext },
        repository,
        kernel: {
            infra: {
                toaster: { useToast },
                optionParser: { useOptions },
            },
        },
    } = config;

    const UrlOptionSchema = z.object({
        integrationId: z.string(),
    });

    return ({ as: View, item, ...containerProps }) => {
        const context = useContext();
        const toast = useToast();
        const navigate = useNavigate();
        const [isHovered, setIsHovered] = useState(false);
        const params = useOptions(UrlOptionSchema);
        const disclosure = {
            menu: useDisclosure(),
        };

        const mutation = {
            integration: {
                delete: repository.platform.integration.useDelete(context),
            },
        };

        const props = controller.useProps(context, item, {
            disclosure,
            hover: {
                value: isHovered,
                onChange: setIsHovered,
            },
            async onDelete() {
                try {
                    await mutation.integration.delete.mutateAsync(item.integration.id);
                    // toast({
                    //     description: `Integration has been deleted`,
                    //     kind: 'info',
                    // });
                    if (params.integrationId === item.integration.id) {
                        console.log(
                            'deleting currently selected integration, navigating to home'
                        );
                        navigate('/reporting', { replace: true });
                    }
                } catch (error) {
                    console.error('Failed to delete integration:', error);
                    toast({
                        description: `Failed to delete integration. Please try again.`,
                        kind: 'error',
                    });
                }
            },
        });

        return <View {...props} />;
    };
}
